module.exports = __webpack_public_path__ + "img/rock-huge-20.7dfed169.png";